import { useBreakpoint } from '@one-thd/sui-atomic-components';

export const useMobileBreakpoint = () => {
  const { lesser: isMobile } = useBreakpoint('lg');

  return isMobile;
}